import {
  type ButtonHTMLAttributes,
  forwardRef,
  type HTMLAttributes,
} from 'react';
import { Dialog } from '@ghq-abi/design-system-v2';

import { cn } from '~/shared/utils/cn';

export const StyledDialogHeader = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('mt-6 mb-6 flex items-center justify-between', className)}
    {...props}
  />
));
StyledDialogHeader.displayName = 'StyledDialogHeader';

export const CloseButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line react/button-has-type
  <button
    ref={ref}
    type="button"
    className={cn(
      'm-0 cursor-pointer border-none bg-transparent p-0',
      className,
    )}
    {...props}
  />
));
CloseButton.displayName = 'CloseButton';

export const CloseButtonWrapper = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex items-center', className)}
    {...props}
  />
));
CloseButtonWrapper.displayName = 'CloseButtonWrapper';

export const StyledDialogMiddleSection = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('h-[100px]', className)} {...props} />
));
StyledDialogMiddleSection.displayName = 'StyledDialogMiddleSection';

export const StyledDialogFooter = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex justify-end gap-4 border-t border-[#EEEFF2] pt-4',
      className,
    )}
    {...props}
  />
));
StyledDialogFooter.displayName = 'StyledDialogFooter';

export const StyledDialogTitle = forwardRef<
  HTMLHeadingElement,
  HTMLAttributes<HTMLHeadingElement>
>(({ className, children, ...props }, ref) => (
  <Dialog.Title
    ref={ref}
    className={cn(
      'm-0 text-[1.125rem] leading-6 font-bold text-[var(--color-text-primary)]',
      className
    )}
    {...props}
  >
    {children}
  </Dialog.Title>
));
StyledDialogTitle.displayName = 'StyledDialogTitle';
